import clsx from "clsx";
import { CheckIcon } from "@/shared/icons";

type Props = {
  isCheck: boolean;
};

export default function HotelCheck({ isCheck }: Props) {
  return (
    <div className="flex justify-center items-center size-6 ml-auto mt-2.5 mr-2.5 bg-dark-900 rounded-[50%]">
      <div
        className={clsx(
          "flex justify-center items-center size-4.5 bg-[#84FF97] rounded-[50%] transition-transform duration-300",
          isCheck ? "scale-100" : "scale-0",
        )}
      >
        <CheckIcon className="w-3 text-dark-900" />
      </div>
    </div>
  );
}
